import { ReactNode } from 'react';
import { Flex, FlexProps, Box, BoxProps } from '@blockanalitica/ui';
import styled from 'styled-components';
import { LinkButton } from '../buttons';
import { ExternalLinkIcon } from '../icons';

const Container = styled(Flex)<FlexProps>`
  position: relative;
  height: 100%;
  overflow: hidden;
  border-radius: ${(props) => props.theme.sizes[-1]};
`;

const LeftBackground = styled(Box)<BoxProps>`
  background: radial-gradient(
    100% 177.78% at 100% 0%,
    rgb(162, 115, 255) 0%,
    rgb(67, 49, 233) 100%
  );
  clip-path: polygon(0px 0px, 0px 100%, 58% 100%, 100% 33%, 100% 0px);
  position: absolute;
  height: 100%;
  width: 110%;
`;

const MiddleBackground = styled(Box)<BoxProps>`
  background: linear-gradient(43deg, #f7a7f9 -2.45%, #6d28ff 100%);
  clip-path: polygon(100% 0px, 10% 100%, 0px 100%, 38% 0px);
  position: absolute;
  height: 100%;
  left: 62%;
  width: 138%;
`;

const RightBackground = styled(Box)<BoxProps>`
  background: rgb(42, 25, 125);
  clip-path: polygon(100% 0px, 100% 100%, 0px 100%, 33% 0px);
  position: absolute;
  height: 100%;
  left: 65%;
  width: 200%;
`;

const ContentContainer = styled(Flex)<FlexProps>`
  position: relative;
  z-index: 1;
  line-height: normal;
  padding: ${(props) => props.theme.space.s};
`;

export interface LinkBannerProps {
  text?: ReactNode;
  linkTo: string;
  children?: ReactNode;
}

export default function LinkBanner({
  text,
  linkTo,
  children
}: LinkBannerProps) {
  return (
    <Container>
      <LeftBackground />
      <MiddleBackground />
      <RightBackground />
      <ContentContainer
        flexDirection={['column', 'row']}
        justifyContent={['flex-start', 'space-between']}
        alignItems="flex-start"
        gap={['s', '0']}>
        <Box paddingRight={['0', 'm']}>{children}</Box>
        <Box alignSelf="flex-start">
          <LinkButton to={linkTo} target="_blank">
            <Flex
              gap="3xs"
              alignItems="center"
              style={{ whiteSpace: 'nowrap' }}>
              {text}
              <ExternalLinkIcon size="1" />
            </Flex>
          </LinkButton>
        </Box>
      </ContentContainer>
    </Container>
  );
}
